<template>
    <v-layout>
        <v-flex xs12>
            <v-card>
                <v-card-title class="headline primary white--text">
                    {{ 'Equipments'|translate }}
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <span style="width:300px;"><v-text-field class="mr-4" clearable v-model="search" type="text"
                                                             :label="'Keyword filter'|translate"></v-text-field></span>
                    <v-btn class="accent" @click="editedItem=null;dialog=true" :disabled="!$can('update', 'Equipment')">
                        <v-icon small class="mr-2">fa-plus</v-icon>
                        {{ 'Add Record'|translate }}
                    </v-btn>
                    <equipment-record-dialog v-model="dialog" :item="editedItem"></equipment-record-dialog>
                </v-card-actions>

                <v-card-text>
                    <v-data-table
                        :headers="headers"
                        :items="equipments"
                        :search="search2"
                        class="elevation-1"
                        :rows-per-page-items="[25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                        :items-per-page="25"
                    >
                        <template v-slot:items="props">
                            <td>{{ props.item.equipment_id }}</td>
                            <td class="text-xs-left">
                                {{ props.item.equipment_name }}
                            </td>
                            <td class="text-xs-left">{{ props.item.equipment_type }}</td>
                            <td class="text-xs-left">
                                {{ props.item.equipment_tags ? props.item.equipment_tags.join(',') : '' }}
                            </td>
                            <td class="text-xs-left">{{ props.item.floor }}</td>
                            <td class="text-xs-left">{{ props.item.facility_name }}</td>
                            <td class="text-xs-left">{{ props.item.meta }}</td>
                            <td class="justify-center layout px-0">
                                <v-icon
                                    small
                                    class="mr-2"
                                    v-if="$can('update', 'Equipment')"
                                    @click="$can('update', 'Equipment') && editItem(props.item)"
                                >
                                    fa-edit
                                </v-icon>
                                <v-icon
                                    small
                                    v-if="$can('update', 'Equipment')"
                                    @click="$can('update', 'Equipment') && deleteItem(props.item)"
                                >
                                    fa-trash
                                </v-icon>
                            </td>
                        </template>
                        <template v-slot:no-data>
                            <v-btn color="primary" @click="initialize">{{ 'Reset'|translate }}</v-btn>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import {getEquipment, deleteEquipment} from '../helper'
import EquipmentRecordDialog from '../components/equipment/EquipmentRecordDialog'

export default {
    name: 'Equipments',
    components: {EquipmentRecordDialog},
    data() {
        return {
            dialog: false,
            search: '',
            search2: '',
            timeout: null,
            headers: [
                {
                    text: this.$options.filters.translate('Equipment ID'),
                    align: 'left',
                    sortable: true,
                    value: 'equipment_id',
                },
                {text: this.$options.filters.translate('Equipment Name'), value: 'equipment_name', sortable: true},
                {text: this.$options.filters.translate('Equipment Type'), value: 'equipment_type', sortable: true},
                {text: this.$options.filters.translate('Equipment Tags'), value: 'equipment_tags', sortable: false},
                {text: this.$options.filters.translate('Floor'), value: 'floor', sortable: true},
                {text: this.$options.filters.translate('Facility Name'), value: 'facility_name'},
                {text: this.$options.filters.translate('Meta'), value: 'meta', sortable: false},
                {text: this.$options.filters.translate('Actions'), sortable: false},
            ],
            equipments: [
                {
                    'equipment_id': 1,
                    'equipment_name': 'Equipment Name',
                    'equipment_type': 'Equipment Type',
                    'facility_name': 'Facility Name',
                    'meta': 'Meta',
                },
            ],
            editedItem: {},
        }
    },
    watch: {
        dialog(newdialog) {
            if (!newdialog) {
                this.refresh()
            }
        },
        search() {
            this.debounce(this.syncSearches, 500);
        }
    },
    mounted() {
        this.initialize()
    },
    methods: {
        initialize() {
            this.refresh()
        },
        syncSearches() {
            this.search2 = this.search
        },
        debounce(callback, wait) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => callback(), wait);
        },

        editItem(item) {
            this.editedItem = Object.assign({}, item)
            this.dialog = true
        },

        async deleteItem(item) {
            if (confirm(this.$options.filters.translate('Are you sure you want to delete this item?'))) {
                await deleteEquipment({
                    'equipment_id': item.equipment_id
                })
                this.refresh()
            }
        },
        async refresh() {
            let df = await getEquipment({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name
            })
            this.equipments = df['result']
        }
    }
}
</script>

<style scoped>

</style>
